import ReactDOM from 'react-dom/client';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import App from "./App.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
      <App/>
  </> 
);